export default {
  CENTER: 1,
  BOTTOM: 2,
};



// WEBPACK FOOTER //
// ./src/default-settings/title-position-values.js